import React from 'react'

// import cn from 'classnames'
import cl from './StoresVideoContainer.scss'

type PropType = {
  children: React.ReactNode
}

const StoresVideoContainer: React.SFC<PropType> = (props) => {
  const { children } = props

  return (
    <div className={cl.storesVideoContainer}>
      {children}
    </div>
  )
}

export default StoresVideoContainer
